import { useEffect } from 'react';
import { useBusiness } from 'hooks/useBusiness';

interface TitleHandlerProps {
	title: string;
	children: React.ReactNode;
}

function TitleHandler({ title, children }: TitleHandlerProps) {
	const { isBusinessLoaded, getBizConfigVar } = useBusiness();
	
	useEffect(() => {
		if (isBusinessLoaded) {
			const businessName = getBizConfigVar('name');
			document.title = title + ' | ' + businessName;
		} else {
			document.title = title;
		}


	}, [title]);

	return <>{children}</>;
}

export default TitleHandler;